<template>
  <div class="container">
    <!-- Branding Superior -->
    <div class="brand-container">
      <span class="brand-bold">MY EVENTO</span>
      <span class="brand-script">Digital</span>
    </div>

    <!-- Tarjeta del Pase Digital -->
    <div class="card-wrapper">
      <div class="card">
        <div class="card-header">
          <h2 class="card-title">Pase Digital</h2>
        </div>

        <div class="card-body">
          <div class="info-item">
            <strong>Nombre a mostrar:</strong>
            <span class="fuente-mayonice">{{ invitado.nombre_mostrar }}</span>
          </div>

          <div class="info-item">
            <strong>Pases Confirmados:</strong>
            <span>{{ invitado.num_pases }}</span>
          </div>

          <div class="info-item">
            <strong># Mesa:</strong>
            <span>{{ invitado.num_mesa }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import baseUrl from '../api';

export default {
  name: "MiPerfil",
  data() {
    return {
      invitado: {
        nombre_mostrar: "",
        num_pases: "",
        num_mesa: "",
      },
    };
  },
  mounted() {
    this.obtenerDatosInvitado();
  },
  methods: {
    async obtenerDatosInvitado() {
      const idInvitado = this.$route.params.id;

      if (idInvitado) {
        try {
          const response = await fetch(`${baseUrl}/codigoqr/invitado/${idInvitado}`);
          const data = await response.json();
          if (data) {
            this.invitado = data;
          }
        } catch (error) {
          console.error("Error al obtener los datos:", error);
        }
      } else {
        console.error("No se encontró id_invitado en la URL");
      }
    },
  },
};
</script>

<style scoped>
.container {
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 100vh;
  background-color: #fff;
}

.brand-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  text-align: center;
}

.brand-bold {
  font-family: 'Playfair Display', serif;
  font-size: 24px;
  font-weight: 500;
  color: #3f3f3f;
}

.brand-script {
  font-family: 'serenety', cursive;
  font-size: 28px;
  color: #8c7e6e;
  margin-top: 4px;
}

.card-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.card {
  width: 100%;
  max-width: 420px;
  background: white;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.05);
  text-align: center;
}

.card-title {
  font-size: 24px;
  font-family: 'Playfair Display', serif;
  color: #4a3f42;
  margin-bottom: 16px;
}

.info-item {
  margin-bottom: 20px;
  font-size: 14px;
}

.info-item strong {
  display: block;
  font-weight: 600;
  color: #5f6770;
  margin-bottom: 6px;
}

.info-item span {
  font-size: 20px;
  color: #333;
}

.fuente-mayonice {
  font-family: 'Mayonice', cursive;
  font-size: 30px;
  color: #4a3f42;
}

@media (max-width: 768px) {
  .card {
    padding: 1.5rem;
  }

  .card-title {
    font-size: 20px;
  }

  .fuente-mayonice {
    font-size: 26px;
  }
}
</style>
